import App from '@/models/App'

export default class TrafficUserSchedule extends App {
    static get entity() {
        return 'TrafficUserSchedules'
    }

    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }

    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }

    static fields() {
        return {
            id: this.attr(''),
            userId: this.attr(''),
            name: this.attr(''),
            title: this.attr(''),
            from: this.attr(''),
            to: this.attr(''),
            comment: this.attr(''),
            background: this.attr(''),
            user: this.attr({}),
        }
    }

    static apiConfig = {
        actions: {
            fetchMine(params) {
                return this.get(`traffic/user/schedules/mine`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            findMine(trafficUserScheduleId) {
                return this.get(
                    `traffic/user/schedules/mine/${trafficUserScheduleId}`,
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            createMine(params) {
                return this.post(
                    `/traffic/user/schedules/mine`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateMine(trafficUserScheduleId, params) {
                return this.patch(
                    `traffic/user/schedules/mine/${trafficUserScheduleId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroyMine(trafficUserScheduleId) {
                return this.delete(
                    `traffic/user/schedules/mine/${trafficUserScheduleId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: trafficUserScheduleId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
